import { geoEquirectangular, geoPath } from "d3-geo";
import { useState, useEffect, useRef } from "react";
import { Tooltip } from "@mui/material";

const missingDataColor = "#fff";

const Marks = ({ countries, rawMapData, data, colorScale }) => {
  const [bounds, setBounds] = useState({ width: 0, height: 0 });

  const projection = geoEquirectangular()
    .scale(1)
    .fitSize([bounds.width, bounds.height], rawMapData)
    .center([0, 10]);
  const path = geoPath(projection);

  const [tooltipContent, setTooltipContent] = useState("");

  const containerRef = useRef();
  const svgRef = useRef();

  // Function that returns the fillColor based on a country id and its value
  const getCountryFill = (id) => {
    const dataCountry =
      data.find((country) => country.country_code === id) || {};
    const countryValue = dataCountry.value;

    return countryValue ? colorScale(countryValue) : missingDataColor;
  };

  const getCountryValue = (id) => {
    const dataCountry =
      data.find((country) => country.country_code === id) || {};

    return dataCountry.value ? dataCountry.value : "no data";
  };

  const handleResize = () => {
    const newDimensions = {
      width: containerRef.current.clientWidth,
      height: containerRef.current.clientHeight,
    };
    setBounds(newDimensions);
  };

  useEffect(() => {
    handleResize();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <Tooltip title={tooltipContent} followCursor enterDelay={0} leaveDelay={0}>
      <div className="country-marks-container" ref={containerRef}>
        <svg
          width="100%"
          height="100%"
          ref={svgRef}
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="marks">
            {countries.map((country) => (
              <path
                className="country"
                id={country.id}
                key={country.id}
                fill={getCountryFill(country.id)}
                d={path(country.geometry)}
                onMouseEnter={() => {
                  setTooltipContent(
                    `${country.properties.name}: ${getCountryValue(country.id)}`
                  );
                }}
                onMouseLeave={() => {
                  setTooltipContent("");
                }}
              />
            ))}
          </g>
        </svg>
      </div>
    </Tooltip>
  );
};

export default Marks;
